import { trackComponent } from "@repo/analytics";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import { getCustomerIdForAnalytics } from "../../utils/analytics-utils";
import {
  PAY_LATER_MTF_CAMPAIGN,
  PAY_LATER_MTF_COMPONENT_NAME,
  PAY_LATER_MTF_ENTRY_POINT,
  PAY_LATER_MTF_JOURNEY_TAG,
  PAY_LATER_MTF_PRODUCT_CATEGORY,
  PAY_LATER_MTF_PRODUCT_NAME,
  PAY_LATER_MTF_PROPERTY_TYPE,
  PAY_LATER_MTF_REFERENCE_ID,
  PAY_LATER_MTF_SPRINT,
} from "./payLaterMtfTrackingConstants";

export interface TrackPayLaterMtfClickParams {
  clickType: string;
  sectionTitle: string;
  ctaText: string;
  componentPosition?: string;
  destinationUrl?: string;
  tabPosition?: string;
}

export const trackPayLaterMtfClick = async ({
  clickType,
  sectionTitle,
  ctaText,
  componentPosition,
  destinationUrl,
  tabPosition,
}: TrackPayLaterMtfClickParams): Promise<void> => {
  try {
    const customerId = await getCustomerIdForAnalytics();

    await trackComponent({
      componentName: PAY_LATER_MTF_COMPONENT_NAME,
      componentId: PAY_LATER_MTF_REFERENCE_ID,
      sectionTitle,
      eventType: dlEventConstants.CLICK,
      clickType,
      ctaText,
      destinationUrl,
      tabPosition,
      productCategory: PAY_LATER_MTF_PRODUCT_CATEGORY,
      cleverTapOverrides: {
        EP_JOURNEY: PAY_LATER_MTF_JOURNEY_TAG,
        EP_PROPERTY_TYPE: PAY_LATER_MTF_PROPERTY_TYPE,
        EP_PRODUCT_NAME: PAY_LATER_MTF_PRODUCT_NAME,
        EP_CAMPAIGN: PAY_LATER_MTF_CAMPAIGN,
        EP_SPRINT: PAY_LATER_MTF_SPRINT,
        EP_REFERENCE_ID: PAY_LATER_MTF_REFERENCE_ID,
        EP_ENTRYPOINT: PAY_LATER_MTF_ENTRY_POINT,
        ...(customerId && { EP_CUSTOMER_ID: customerId }),
        ...(componentPosition && { EP_SR_NUMBER: componentPosition }),
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to track pay later MTF click", error);
  }
};
